import { render } from "./AboutView.vue?vue&type=template&id=0cf90f0c&scoped=true"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"

import "@/assets/css/app.a60e7e5f.css?vue&type=style&index=0&id=0cf90f0c&scoped=true&lang=css&external"
import "./AboutView.vue?vue&type=style&index=1&id=0cf90f0c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf90f0c"]])

export default __exports__